import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Input from './components/Input';
import Button from './components/Button'
import fetchWP from './utils/fetchWP';
import Toggle from 'react-toggle';
import ReactResponsiveSelect from 'react-responsive-select';
import Loader from './utils/loader'

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px" viewBox="351.584 2118.292 11.848 6.338">
      <g><path d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/></g>
    </svg>
);

const timeZones = [ {text: "Dateline Standard Time (UTC-12:00)",value: "-12:00"},
{text: "UTC-11",value: "-11:00"},
{text: "Hawaiian Standard Time (UTC-10:00)",value: "-10:00"},
{text:"Alaskan Standard Time (UTC-09:00)", value: "-09:00"},
{text: "Pacific Standard Time (Mexico) (UTC-08:00)", value: "-08:00"},
{text: "Pacific Daylight Time (UTC-07:00)", value: "-07:00"},
{text: "Pacific Standard Time (UTC-08:00)", value: "-08:00"},
{text: "US Mountain Standard Time (UTC-07:00)",value: "-07:00"},
{text: "Mountain Standard Time (Mexico) (UTC-07:00)",value: "-07:00"},
{text: "Mountain Standard Time (UTC-07:00)",value: "-07:00"},
{text: "Central America Standard Time (UTC-06:00)",value: "-06:00"},
{text: "Central Standard Time (UTC-06:00)",value: "-06:00"},
{text: "Central Standard Time (Mexico) (UTC-06:00)",value: "-06:00"},
{text: "Canada Central Standard Time (UTC-06:00)",value: "-06:00"},
{text: "SA Pacific Standard Time (UTC-05:00)",value: "-05:00"},
{text: "Eastern Standard Time (UTC-05:00)",value: "-05:00"},
{text: "US Eastern Standard Time (UTC-05:00)",value: "-05:00"},
{text: "Venezuela Standard Time (UTC-04:30)",value: "-04:30"},
{text: "Paraguay Standard Time (UTC-04:00)",value: "-04:00"},
{text: "Atlantic Standard Time (UTC-04:00)",value: "-04:00"},
{text: "Central Brazilian Standard Time (UTC-04:00)",value: "-04:00"},
{text: "SA Western Standard Time (UTC-04:00)",value: "-04:00"},
{text: "Pacific SA Standard Time (UTC-04:00)",value: "-04:00"},
{text: "Newfoundland Standard Time (UTC-03:30)",value: "-03:30"},
{text: "E. South America Standard Time (UTC-03:00)",value: "-03:00"},
{text: "Argentina Standard Time (UTC-03:00)",value: "-03:00"},
{text: "SA Eastern Standard Time (UTC-03:00)",value: "-03:00"},
{text: "Greenland Standard Time (UTC-03:00)",value: "-03:00"},
{text: "Montevideo Standard Time (UTC-03:00)",value: "-03:00"},
{text: "Bahia Standard Time (UTC-03:00)",value: "-03:00"},
{text: "UTC-02",value: "-02:00"},
{text: "Mid-Atlantic Standard Time (UTC-02:00)",value: "-02:00"},
{text: "Azores Standard Time (UTC-01:00)",value: "-01:00"},
{text: "Cape Verde Standard Time (UTC-01:00)",value: "-01:00"},
{text: "Morocco Standard Time ",value: "00:00"},
{text: "UTC",value: "00:00"},
{text: "Greenwich Mean Time ",value: "00:00"},
{text: "British Summer Time (UTC+01:00)",value: "+01:00"},
{text: "GMT Standard Time ",value: "00:00"},
{text: "Greenwich Standard Time ",value: "00:00"},
{text: "W. Europe Standard Time (UTC+01:00)",value: "+01:00"},
{text: "Central Europe Standard Time (UTC+01:00)",value: "+01:00"},
{text: "Romance Standard Time (UTC+01:00)",value: "+01:00"},
{text: "Central European Standard Time (UTC+01:00)",value: "+01:00"},
{text: "W. Central Africa Standard Time (UTC+01:00)",value: "+01:00"},
{text: "Namibia Standard Time (UTC+01:00)",value: "+01:00"},
{text: "GTB Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Middle East Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Egypt Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Syria Standard Time (UTC+02:00)",value: "+02:00"},
{text: "E. Europe Standard Time (UTC+02:00)",value: "+02:00"},
{text: "South Africa Standard Time (UTC+02:00)",value: "+02:00"},
{text: "FLE Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Turkey Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Israel Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Libya Standard Time (UTC+02:00)",value: "+02:00"},
{text: "Jordan Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Arabic Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Kaliningrad Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Arab Standard Time (UTC+03:00)",value: "+03:00"},
{text: "E. Africa Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Moscow Standard Time (UTC+03:00)",value: "+03:00"},
{text: "Samara Time (UTC+04:00)",value: "+04:00"},
{text: "Iran Standard Time (UTC+03:30)",value: "+03:30"},
{text: "Arabian Standard Time (UTC+04:00)",value: "+04:00"},
{text: "Azerbaijan Standard Time (UTC+04:00)",value: "+04:00"},
{text: "Mauritius Standard Time (UTC+04:00)",value: "+04:00"},
{text: "Georgian Standard Time (UTC+04:00)",value: "+04:00"},
{text: "Caucasus Standard Time (UTC+04:00)",value: "+04:00"},
{text: "Afghanistan Standard Time (UTC+04:30)",value: "+04:30"},
{text: "West Asia Standard Time (UTC+05:00)",value: "+05:00"},
{text: "Yekaterinburg Time (UTC+05:00)",value: "+05:00"},
{text: "Pakistan Standard Time (UTC+05:00)",value: "+05:00"},
{text: "India Standard Time (UTC+05:30)",value: "+05:30"},
{text: "Sri Lanka Standard Time (UTC+05:30)",value: "+05:30"},
{text: "Nepal Standard Time (UTC+05:45)",value: "+05:45"},
{text: "Central Asia Standard Time (UTC+06:00)",value: "+06:00"},
{text: "Bangladesh Standard Time (UTC+06:00)",value: "+06:00"},
{text: "Myanmar Standard Time (UTC+06:30)",value: "+06:30"},
{text: "SE Asia Standard Time (UTC+07:00)",value: "+07:00"},
{text: "N. Central Asia Standard Time (UTC+07:00)",value: "+07:00"},
{text: "China Standard Time (UTC+08:00)",value: "+08:00"},
{text: "North Asia Standard Time (UTC+08:00)",value: "+08:00"},
{text: "Singapore Standard Time (UTC+08:00)",value: "+08:00"},
{text: "W. Australia Standard Time (UTC+08:00)",value: "+08:00"},
{text: "Taipei Standard Time (UTC+08:00)",value: "+08:00"},
{text: "Ulaanbaatar Standard Time (UTC+08:00)",value: "+08:00"},
{text: "North Asia East Standard Time (UTC+09:00)",value: "+09:00"},
{text: "Japan Standard Time (UTC+09:00)",value: "+09:00"},
{text: "Korea Standard Time (UTC+09:00)",value: "+09:00"},
{text: "Cen. Australia Standard Time UTC+09:30)",value: "+09:30"},
{text: "AUS Central Standard Time UTC+09:30)",value: "+09:30"},
{text: "E. Australia Standard Time (UTC+10:00)",value: "+10:00"},
{text: "AUS Eastern Standard Time (UTC+10:00)",value: "+10:00"},
{text: "West Pacific Standard Time (UTC+10:00)",value: "+10:00"},
{text: "Tasmania Standard Time (UTC+10:00)",value: "+10:00"},
{text: "Yakutsk Standard Time (UTC+10:00)",value: "+10:00"},
{text: "Central Pacific Standard Time (UTC+11:00)", value: "+11:00"},
{text: "Vladivostok Standard Time (UTC+11:00)",value: "+11:00"},
{text: "New Zealand Standard Time (UTC+12:00)",value: "+12:00"},
{text: "UTC+12",value: "+12:00"},
{text: "Fiji Standard Time (UTC+12:00)",value: "+12:00"},
{text: "Magadan Standard Time (UTC+12:00)", value: "+12:00"},
{text: "Kamchatka Standard Time (UTC+12:00)", value: "+12:00"},
{text: "Tonga Standard Time (UTC+13:00)", value: "+13:00"},
{text: "Samoa Standard Time (UTC+13:00)", value: "+13:00"} ];

export default class Listing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            time_zone:'',
            multiple:'',
        }
        this.handleSelect = this.handleSelect.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });
    }

    handleSelect (e)  {
        let value = e.value;
        let name = e.name;
        console.log(e);
        this.setState({ [name]: value });
    }

    handleStatusChange(e){
        let value = e.target.checked;
        let name = e.target.name;
        this.setState({ [name]: value });
    }

    handleFormSubmit(e) {
        e.preventDefault();
        let data = this.state;
        console.log(data);
        // this.fetchWP.post('awdp_settings', data)
        //     .then(
        //         (json) => { 
        //             this.setState({
        //                 time_zone: {text: "Romance Standard Time (UTC+01:00)",value: "+01:00"}
        //             }); 
        //         }
        //     );
    }
    
    componentDidMount() {
        this.fetchWP.get('awdp_settings')
            .then(
                (json) => { 
                    console.log(json);
                    this.setState({
                        time_zone: {name: "time_zone", text: "Alaskan Standard Time (UTC-09:00)", value: "-09:00", altered: true}
                    }); 
                    console.log(this.state.time_zone);
                }
            );
    };

    render() {
        return (
            <div className="awdp_settings clearfix">
                <div className="awdp_field_group">
                    <div className="form-group">
                        <label className="form-label">Time Zone</label>
                        <ReactResponsiveSelect
                            name={'time_zone'}
                            options={timeZones} 
                            caretIcon={caretIcon}
                            noSelectionLabel={'Select Time Zone'}
                            onChange={this.handleSelect}
                            selectedValue={this.state.time_zone} />
                    </div> 
                    <div className="form-group">
                        <div className="sub-group">
                            <label className="form-label">Apply multiple discount on single product</label>
                            <Toggle
                                name={'status'}
                                icons={false}
                                value={this.state.multiple}
                                checked={this.state.multiple}
                                onChange={this.handleStatusChange} />
                        </div>
                        <div className="sub-group">
                            {/* <Input inputType={'number'}
                                title={'Priority'}
                                name={'priority'}
                                value={this.state.rule.priority}
                                placeholder={'Enter discount priority'}
                                handleChange={this.handleInput} /> */}
                        </div>
                    </div>
                    <div className="save_changes">
                        <Button action={
                            this.handleFormSubmit}
                            type={'update'}
                            title={'Update'} 
                             />
                    </div>
                </div>
            </div>
        )
    }
}
